/* Resume lives on Drive so visitors read it in the browser instead of
   downloading a file. Update this one line to swap the resume. */
export const RESUME_URL = "https://drive.google.com/file/d/1OxcCcy2d9eOR7O_E62Xazx7qj9y5SsLE/view";

export const portfolioData = {
  personalInfo: {
    name: "Adhiraj Singh",
    title: "Full Stack Developer",
    subtitle: "MERN Stack Specialist",
    bio: "Developer building agentic AI systems (LangGraph, RAG, tool-calling) and full-stack apps (Next.js, FastAPI, Node.js). Strong DSA fundamentals with a hackathon-winning track record.",
    email: "adhirajsingh00000@gmail.com",
    phone: "+91 8604904661",
    location: "Bengaluru, Karnataka, IN",
    profileImage: "/profile.jpg",
    social: {
      github: "https://github.com/ADHIRAJ00000",
      linkedin: "https://www.linkedin.com/in/adhiraj-singh-bb511127b/",

      email: "adhirajsingh00000@gmail.com"
    }
  },

  education: [
    {
      degree: "Bachelor of Engineering",
      institution: "BMS Institute of Technology & Management",
      field: "Electronics and Telecommunication",
      period: "2023 - Present",
      grade: "CGPA: 8.00",
      current: true
    },
    {
      degree: "ISC (XII)",
      institution: "Shri J.N. Shah Inter College",
      field: "Science",
      period: "2021-2022",
      grade: "91.25%"
    },
    {
      degree: "ICSE (X)",
      institution: "Shri J.N. Shah Inter College",
      field: "General",
      period: "2019-2020",
      grade: "92%"
    }
  ],

  stats: {
    projectsCompleted: 15,
    technologiesMastered: 25,
    cgpa: "8.00",
    awardsWon: 3
  },

  skills: {
    categories: [
      { id: 'all', label: 'All Skills', icon: 'fa-code' },
      { id: 'ai', label: 'AI / ML', icon: 'fa-robot' },
      { id: 'frontend', label: 'Frontend', icon: 'fa-desktop' },
      { id: 'backend', label: 'Backend', icon: 'fa-server' },
      { id: 'database', label: 'Database', icon: 'fa-database' },
      { id: 'languages', label: 'Languages', icon: 'fa-code' },
      { id: 'tools', label: 'Tools', icon: 'fa-wrench' },
      { id: 'cs', label: 'CS Fundamentals', icon: 'fa-book' }
    ],
    technical: [
      { name: "LangChain", category: "ai", icon: "fas fa-link", note: "2 Projects", color: "#1C9C7C" },
      { name: "LangGraph", category: "ai", icon: "fas fa-diagram-project", note: "2 Projects", color: "#14B8A6" },
      { name: "RAG", category: "ai", icon: "fas fa-magnifying-glass", note: "2 Projects", color: "#6366F1" },
      { name: "FAISS", category: "ai", icon: "fas fa-vector-square", note: "1 Project", color: "#4267B2" },
      { name: "Vector Databases", category: "ai", icon: "fas fa-cubes", note: "2 Projects", color: "#10B981" },
      { name: "LLM Integration", category: "ai", icon: "fas fa-robot", note: "2 Projects", color: "#7C3AED" },
      { name: "React.js", category: "frontend", icon: "fab fa-react", note: "7 Projects", color: "#06B6D4" },
      { name: "Next.js", category: "frontend", icon: "fas fa-forward", note: "2 Projects", color: "#0F172A" },
      { name: "Node.js", category: "backend", icon: "fab fa-node", note: "6 Projects", color: "#339933" },
      { name: "Express.js", category: "backend", icon: "fas fa-server", note: "5 Projects", color: "#374151" },
      { name: "FastAPI", category: "backend", icon: "fas fa-rocket", note: "2 Projects", color: "#009688" },
      { name: "MongoDB", category: "database", icon: "fas fa-database", note: "6 Projects", color: "#47A248" },
      { name: "JavaScript", category: "languages", icon: "fab fa-js", note: "10+ Projects", color: "#EAB308" },
      { name: "TypeScript", category: "languages", icon: "fas fa-code", note: "2 Projects", color: "#3178C6" },
      { name: "Python", category: "languages", icon: "fab fa-python", note: "5 Projects", color: "#3776AB" },
      { name: "C++", category: "languages", icon: "fas fa-code", note: "DSA & 4 Projects", color: "#00599C" },
      { name: "Java", category: "languages", icon: "fab fa-java", note: "3 Projects", color: "#E76F00" },
      { name: "HTML/CSS", category: "frontend", icon: "fab fa-html5", note: "10+ Projects", color: "#E34F26" },
      { name: "Tailwind CSS", category: "frontend", icon: "fab fa-css3-alt", note: "8 Projects", color: "#06B6D4" },
      { name: "Git/GitHub", category: "tools", icon: "fab fa-git-alt", note: "Used Daily", color: "#F05032" },
      { name: "Docker", category: "tools", icon: "fab fa-docker", note: "3 Projects", color: "#2496ED" },
      { name: "SQL", category: "database", icon: "fas fa-database", note: "4 Projects", color: "#4479A1" },
      { name: "PostgreSQL", category: "database", icon: "fas fa-database", note: "2 Projects", color: "#4169E1" },
      { name: "Redis", category: "database", icon: "fas fa-bolt", note: "2 Projects", color: "#DC382D" },
      { name: "SupaBase", category: "database", icon: "fas fa-bolt", note: "2 Projects", color: "#3ECF8E" },
      { name: "DSA", category: "cs", icon: "fas fa-brain", note: "500+ Problems", color: "#6366F1" },
      { name: "System Design", category: "cs", icon: "fas fa-project-diagram", note: "Strong Foundation", color: "#0EA5E9" },
      { name: "DBMS", category: "cs", icon: "fas fa-server", note: "Core Concept", color: "#8B5CF6" },
      { name: "Operating System", category: "cs", icon: "fas fa-desktop", note: "Core Concept", color: "#64748B" },
      { name: "Computer Networks", category: "cs", icon: "fas fa-network-wired", note: "Core Concept", color: "#0891B2" },
      { name: "OOPs", category: "cs", icon: "fas fa-cubes", note: "Core Concept", color: "#EC4899" },
      { name: "Redux", category: "frontend", icon: "fas fa-layer-group", note: "3 Projects", color: "#764ABC" }
    ]
  },

  projects: [
    {
      title: "Omnix AI",
      visual: {
        icon: "fas fa-diagram-project",
        lines: ["SUPERVISOR", "6 AGENTS"],
        modules: ["CHAT", "SEARCH", "CODE", "VISION", "RAG", "DOCS"]
      },
      category: "AGENTIC AI PLATFORM",
      accent: "#06B6D4",
      tagline: "A multi-agent AI platform where a LangGraph supervisor routes every request to the right specialist agent.",
      description: "Multi-agent AI platform built as microservices: a LangGraph supervisor routes each request to a specialist agent \u2014 chat, web search, coding, vision, PDF/PPT generation, and RAG over uploaded documents. Ships with its own JWT auth (refresh-token rotation + Google sign-in), an append-only credit ledger, Razorpay billing, Redis, Qdrant, S3 and Docker.",
      highlights: [
        { icon: "fas fa-diagram-project", label: "LangGraph Supervisor" },
        { icon: "fas fa-robot", label: "6 Specialist Agents" },
        { icon: "fas fa-user-shield", label: "JWT + Google Sign-In" },
        { icon: "fas fa-credit-card", label: "Credit Ledger & Billing" }
      ],
      technologies: ["Node.js", "LangGraph", "React", "Qdrant", "Redis", "Docker"],
      github: "https://github.com/ADHIRAJ00000/Omnix-AI",
    //  demo: "https://cortex-ai-tau-seven.vercel.app",
      // login-walled, so cycle product shots instead of a live iframe
      slideMs: 3000,
      screenshots: [
        { src: "/screenshots/omnix-1-chat.jpg", alt: "Chat agent answering with a C++ implementation of Kadane's algorithm" },
        { src: "/screenshots/omnix-2-coding.jpg", alt: "Coding agent: LeetCode solution alongside a generated multi-file code workspace" },
        { src: "/screenshots/omnix-3-tools.jpg", alt: "PPT and image agents returning a generated presentation and image download" }
      ]
    },
    {
      title: "Autonomous AI PR Reviewer",
      visual: {
        icon: "fas fa-code-pull-request",
        lines: ["DIFF SCAN", "REVIEWED"],
        modules: ["DIFF", "SECURITY", "TESTS", "GUARDRAILS", "TRACE"]
      },
      category: "MULTI-AGENT SYSTEMS",
      // the app's own UI is white / black / grey
      accent: "#64748B",
      tagline: "Autonomous multi-agent reviewer that reads pull-request diffs, flags security issues, and suggests tests.",
      description: "Autonomous multi-agent PR reviewer built with LangGraph & FastAPI. Specialized tool-calling agents analyze diffs, flag security issues, and suggest tests \u2014 with guardrails, Langfuse tracing, and an LLM-as-judge eval harness.",
      highlights: [
        { icon: "fas fa-diagram-project", label: "Multi-Agent Graph" },
        { icon: "fas fa-bug-slash", label: "Security Flagging" },
        { icon: "fas fa-chart-line", label: "Langfuse Tracing" },
        { icon: "fas fa-gavel", label: "LLM-as-Judge Evals" }
      ],
      technologies: ["Python", "LangGraph", "FastAPI", "Langfuse", "Docker"],
      github: "https://github.com/ADHIRAJ00000/AI-PR-Reviewer",
      demo: "https://ai-pr-reviewer-m2t1.onrender.com/",
      // static product shots cycle in the preview frame instead of a live iframe
      screenshots: [
        { src: "/screenshots/pr-reviewer-1.jpg", alt: "Autonomous PR Reviewer landing page with the idle agent pipeline" },
        { src: "/screenshots/pr-reviewer-2.jpg", alt: "Completed review: all agents green, security finding and metrics" }
      ]
    },
    {
      title: "Event-Sourced Ledger ",
      visual: {
        icon: "fas fa-scale-balanced",
        lines: ["DR = CR", "IMMUTABLE"],
        modules: ["EVENTS", "REPLAY", "BALANCES", "JWT"]
      },
      category: "BACKEND & FINTECH",
      // dashboard reads as light blue shading into violet
      accent: "#6366F1",
      tagline: "Double-entry ledger API with an immutable event log and point-in-time balance reconstruction.",
      description: "Event-sourced, double-entry ledger API built with FastAPI, async SQLAlchemy and JWT auth. Every transaction is an immutable event, so balances can be replayed at any point in time \u2014 with a built-in web UI for inspecting accounts and history.",
      highlights: [
        { icon: "fas fa-scale-balanced", label: "Double-Entry Ledger" },
        { icon: "fas fa-clock-rotate-left", label: "Immutable History" },
        { icon: "fas fa-calendar-day", label: "Point-in-Time Balances" },
        { icon: "fas fa-key", label: "JWT Auth" }
      ],
      technologies: ["Python", "FastAPI", "SQLAlchemy", "JWT", "Docker"],
      github: "https://github.com/ADHIRAJ00000/Event-Sourced-Ledger",
      demo: "https://event-sourced-ledger.onrender.com/",
      // login-walled, so show product shots rather than a live iframe
      screenshots: [
        { src: "/screenshots/ledger-1.jpg", alt: "Ledger dashboard: four accounts with balances replayed from the event log" },
        { src: "/screenshots/ledger-2.jpg", alt: "Account detail: immutable audit trail with running balance and committed transactions" }
      ]
    },
    {
      title: "Convoy Command Unit",
      visual: {
        icon: "fas fa-route",
        lines: ["CONVOY", "TRACKING"],
        modules: ["TELEMETRY", "ROUTING", "SOCKETS", "ANALYTICS"]
      },
      category: "DEFENCE TECH",
      // terrain / convoy UI is tan shading into orange
      accent: "#D97706",
      // shows a trophy in the row's top-left corner
      award: "Code Red 3.0 — Overall Runner-Up & Best Software Team Award",
      tagline: "AI-driven convoy command platform with real-time tracking, route optimization, and live analytics.",
      description: "AI-driven convoy command & mobility platform for military operations \u2014 real-time tracking, route optimization, and live analytics. Built with Next.js, Node/Express and MongoDB, using Socket.io for live updates. Won Overall Runner-Up and Best Software Team Award at Code Red 3.0 A National-Level Hackathon.",
      highlights: [
        { icon: "fas fa-satellite-dish", label: "Real-Time Tracking" },
        { icon: "fas fa-route", label: "Route Optimization" },
        { icon: "fas fa-bolt", label: "Socket.io Live Updates" },
        { icon: "fas fa-trophy", label: "Hackathon Winner" }
      ],
      technologies: ["Next.js", "TypeScript", "Node.js", "MongoDB", "Socket.io"],
      github: "https://github.com/ADHIRAJ00000/Convoy-Command-Unit",
      demo: "https://convoy-command-unit.vercel.app/",
      // site sends X-Frame-Options: DENY and is login-walled, so show product shots
      embeddable: false,
      slideMs: 3000,
      screenshots: [
        { src: "/screenshots/convoy-1-home.jpg", alt: "HawkRoute landing page with convoy intelligence metrics and live inject feed" },
        { src: "/screenshots/convoy-2-dashboard.jpg", alt: "Operational dashboard: satellite route map, active convoys and checkpoint timeline" },
        { src: "/screenshots/convoy-3-simulator.jpg", alt: "Event Lab simulator running under rain conditions with live progress tracking" },
        { src: "/screenshots/convoy-4-pilot.jpg", alt: "Pilot vehicle route reconnaissance: 3D terrain map with 867 active hazards" }
      ]
    },
    {
      title: "RAG Based Video Intelligence Assistant",
      visual: {
        icon: "fas fa-circle-play",
        lines: ["FAISS", "RAG Q&A"],
        modules: ["TRANSCRIBE", "EMBED", "RETRIEVE", "ANSWER"]
      },
      category: "RAG & LLM",
      accent: "#EF4444",
      tagline: "Production-ready YouTube summarizer and Q&A bot powered by a FAISS + LLM retrieval pipeline.",
      description: "Production-ready YouTube summarizer and Q&A assistant built on a RAG pipeline (FAISS + LLM). Ask questions about any video and get grounded answers, delivered through both a Telegram bot and a React web app, with multi-language support.",
      highlights: [
        { icon: "fas fa-vector-square", label: "FAISS Vector Search" },
        { icon: "fas fa-language", label: "Multi-Language" },
        { icon: "fab fa-telegram", label: "Telegram + Web UI" },
        { icon: "fas fa-comments", label: "Grounded Q&A" }
      ],
      technologies: ["Python", "FastAPI", "FAISS", "RAG", "React", "Telegram"],
      github: "https://github.com/ADHIRAJ00000/RAG-Based-Video-Intelligence-QA-Assistant",
      demo: "https://yt-telegram-bot-summarizer.vercel.app"
    },
    {
      title: "Enterprise Retail Intelligence Platform",
      visual: {
        icon: "fas fa-chart-column",
        lines: ["2.87M ROWS", "AUC 0.81"],
        modules: ["WAREHOUSE", "RFM", "COHORTS", "FORECAST", "CHURN"]
      },
      category: "DATA & ML",
      // dark dashboard on deep blue
      accent: "#2563EB",
      tagline: "Retail BI pipeline: a 2.87M-row star-schema warehouse feeding analytics, forecasting, and a churn model.",
      description: "Production-style retail BI and ML platform: a 2.87M-row star-schema warehouse feeds an analytics engine (RFM, cohorts, ABC analysis, forecasting), a churn model scoring ROC-AUC 0.81, and an interactive dashboard. Built with Python, pandas, scikit-learn and PostgreSQL.",
      highlights: [
        { icon: "fas fa-database", label: "2.87M-Row Warehouse" },
        { icon: "fas fa-chart-line", label: "Churn Model ROC-AUC 0.81" },
        { icon: "fas fa-users", label: "RFM & Cohort Analysis" },
        { icon: "fas fa-arrow-trend-up", label: "Demand Forecasting" }
      ],
      technologies: ["Python", "pandas", "scikit-learn", "PostgreSQL", "SQL"],
      github: "https://github.com/ADHIRAJ00000/ERIP-Enterprise-Retail-Intelligence-Platform",
      demo: "https://erip-enterprise-retail-intelligence-delta.vercel.app",
      slideMs: 3000,
      screenshots: [
        { src: "/screenshots/erip-overview.jpg", alt: "Overview tab: revenue, gross profit and orders with a 6-month forecast" },
        { src: "/screenshots/erip-customers.jpg", alt: "Customers tab: RFM segmentation with the CRM playbook for each segment" },
        { src: "/screenshots/erip-churn.jpg", alt: "Churn ML tab: ROC-AUC 0.812 model with revenue at risk and churn drivers" },
        { src: "/screenshots/erip-whatif.jpg", alt: "What-If tab: marketing budget reallocation and retention campaign planner" }
      ]
    }
  ],

  achievements: [
    {
      title: "National Level Hackathon Winner",
      date: "December 2025",
      description: "Developed 'Convoy Command Unit,' a DefenceTech convoy intelligence system for coordination, route planning, and real-time decision support.",
      highlight: "Secured 'Overall Runner-Up' and 'Best Software Team Award'",
      icon: "trophy",
      side: "left"
    },
    {
      title: "HACKHZARDS '24",
      date: "2024",
      description: "Achieved a Top 100 ranking among 2,900+ teams in one of India’s largest community-driven hackathons.",
      highlight: "Top 100 / 2900+ teams",
      icon: "award",
      side: "right"
    },
    {
      title: "State Level Basketball Player ",
      date: "2019",
      description: "Represented the North-Zone Kanpur in State Level basketball competitions, demonstrating leadership and teamwork.",
      highlight: "State Level Recognition",
      icon: "basketball",
      side: "left"
    }
  ]
};
